import { config } from '../config';

interface Options {
  width: number;
  height: number;
  zoom?: number;
}

export const mapImageUrl = (
  [lat, lng]: readonly [number, number],
  { width, height, zoom = 12.43 }: Options,
) => {
  return `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s+4E2DB2(${lng},${lat})/${lng},${lat},${zoom},0/${width}x${height}@2x?access_token=${config.mapboxToken}&attribution=false&logo=false`;
};
